/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Post_Purchase_CongratulationsInputs */

const en_post_purchase_congratulations = /** @type {(inputs: Post_Purchase_CongratulationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Congratulations`)
};

const es_post_purchase_congratulations = /** @type {(inputs: Post_Purchase_CongratulationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Felicitaciones`)
};

/**
* | output |
* | --- |
* | "Congratulations" |
*
* @param {Post_Purchase_CongratulationsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const post_purchase_congratulations = /** @type {((inputs?: Post_Purchase_CongratulationsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Post_Purchase_CongratulationsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_post_purchase_congratulations(inputs)
	return en_post_purchase_congratulations(inputs)
});